import { queryOptions, useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api-client'
import { QueryConfig } from '@/lib/react-query'
import { BillingDelinquencyInfo, BillingRestrictionInfo } from '../billingRestriction'

export type Account = {
	id: string
	email: string
	type: number
	name: string
	streetAddress1: string | null
	streetAddress2: string | null
	city: string | null
	state: string | null
	phone: string
	subscriptionId: string | null
	backupToolInstalled: boolean
	backupToolOutOfDate: boolean
	backupToolInstanceVersions: string[]
	latestBackupToolVersion: string
	isDisabled: boolean
	billingRestriction?: BillingRestrictionInfo | null
	billingDelinquency?: BillingDelinquencyInfo | null
}

export const getAccount = (id: string): Promise<Account> => {
	return api.get(`/accounts/${id}`)
}

export const getAccountQueryOptions = (accountId: string) => {
	return queryOptions({
		queryKey: ['accounts', accountId],
		queryFn: () => getAccount(accountId),
	})
}

type UseCommentsOptions = {
	accountId: string
	queryConfig?: QueryConfig<typeof getAccount>
}

export const useAccount = ({ accountId, queryConfig }: UseCommentsOptions) => {
	return useQuery({
		...getAccountQueryOptions(accountId),
		...queryConfig,
	})
}
